const initialState = {
    step: 1,
    currentMembership: null,
    data: {
        email : "",
        email_verified : false,
        mobile_number : "",
        mobile_verified : false,
    }
};

export function processReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_STEP_DATA':
            return {
                ...state,
                step: action.payload.step
            };
        case 'SET_CURRENT_MEMBERSHIP':
            return {
                ...state,
                currentMembership: action.payload.currentMembership
            };
        case 'SET_PROCESS_DATA':
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload.data
                }
        }
        case 'CLEAR_PROCESS_DATA':
            return {
                ...state,
                step: 1,
                currentMembership: null,
                data: {}
            };
        default:
            return state;
    }
}